import { jsx as _jsx } from "react/jsx-runtime";
import LegalFormMultiSelect from '../multiselect/LegalFormMultiSelect';
export var FilterLegalFormMultiSelect = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled, _b = _a.showWithoutOption, showWithoutOption = _b === void 0 ? false : _b;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(LegalFormMultiSelect, { selection: activeFilters[item], onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, placeholder: undefined, showWithoutOption: showWithoutOption })),
    });
};
